import React from "react";
import "./SubHeader.css";

const SubHeader = (props) => {
  return (
    <div>
      <div className="about-container">
        <div className={` py-4 d-flex justify-content-between align-items-center ${props.width}`}>
          <div>
            <h3 className="text-white m-0 bold">{props.title}</h3>
          </div>
          <div>
            <nav aria-label="breadcrumb">
              <ol className="breadcrumb m-0">
                <li className="breadcrumb-item">
                  <a href="/" className="text-white ">
                    Home
                  </a>
                </li>
                <li
                  className="breadcrumb-item active cl-pm"
                  aria-current="page"
                >
                  {props.text}
                </li>
              </ol>
            </nav>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubHeader;
